<template>
  <q-dialog ref="generator">
    <q-card class="full-width">
      <q-card-section class="bg-primary text-white row justify-center items-center text-h6">
        JSONPath generator
        <q-space/>
        <q-btn v-if="result" label="Apply" flat icon="send" @click="applyValue"/>
        <q-btn icon="close" label="close" v-close-popup flat/>
      </q-card-section>

      <q-card-section>
        <q-input
            v-model="prompt"
            type="textarea"
            placeholder="Text prompt"
            autogrow
        >
          <template v-slot:append>
            <q-btn label="Generate" flat color="primary" icon="send" @click="generateJsonPath"/>
          </template>
        </q-input>
      </q-card-section>

      <q-card-section class="bg-grey-2"  v-if="result">
        <q-input type="textarea" autogrow v-model="result" hint="Generated JSONPath"/>
      </q-card-section>
    </q-card>

  </q-dialog>
  <q-btn icon="draw_collage" round size="sm" flat @click="$refs.generator.show()"/>
</template>

<script>
export default {
  name: "AiJsonPathGenerator",
  props: ['modelValue', 'parentId'],
  emits: ['update:modelValue'],
  data() {
    return {
      prompt: '',
      result: '',
    };
  },

  computed: {
    moduleId() {
      return this.$route.params.module_id;
    },
  },

  methods: {
    /**
     * Applies the generated JSONPath value to the model and closes the dialog.
     * Emits 'update:modelValue' and 'close' events.
     */
    applyValue() {
      // Update model
      this.$emit('update:modelValue', this.result)
      this.$emit('close')
      this.$refs.generator.hide()
    },

    /**
     * Generates a JSONPath based on the provided prompt, moduleId, and parentId.
     * Shows a loading indicator while the request is being processed.
     * Updates the result with the generated JSONPath or shows an error notification if the request fails.
     */
    async generateJsonPath() {
      // Show loading
      this.$q.loading.show()

      try {
        // Generate
        this.result = await this.app.client.call("ai-designer", "generateJsonPath", {
          prompt: this.prompt,
          moduleId: this.moduleId,
          parentId: this.parentId,
        })
      } catch (e) {
        this.$q.notify({
          color: 'negative',
          message: e.message,
          icon: 'report_problem',
          position: 'top'
        })
      } finally {
        // Hide
        this.$q.loading.hide();
      }
    }
  },
}
</script>
